export enum HttpHeader {
  Authorization = 'authorization',
  ClientId = 'x-dw-client-id',
  ContentType = 'content-Type',
}
